import { useEffect } from 'react'
import { InvoicesTable } from './InvoicesTable/InvoicesTable'
import { InvoicesDetailsGeneral } from './InvoicesDetailsGeneral'
import { useFinancialsContext } from '../../../../Providers/FinancialsProvider'
import { InvoicesDetailsProps } from './types'
import './styles.scss'

export const InvoicesDetails = ({
  invoiceData,
  showVendor = true,
  showHSName
}: InvoicesDetailsProps) => {
  const {
    actions: { setId }
  } = useFinancialsContext()

  useEffect(() => {
    setId(invoiceData.uuid || '')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceData.uuid])

  return (
    <div className="invoices-details column gap-32">
      <InvoicesDetailsGeneral
        invoiceData={invoiceData}
        showVendor={showVendor}
        showHSName={showHSName}
      />
      <InvoicesTable />
    </div>
  )
}
